<div class="fleet-list-page">
  <div class="page-header">
    <div class="header-text">
      <h2>Ficha de veículos</h2>
      <p>
        Veículos identificados pelos checklists. Clique em uma linha para abrir
        a ficha completa do veículo.
      </p>
    </div>
    <div class="header-actions">
      <button nz-button nzType="default" (click)="clearFilters()">
        Limpar filtros
      </button>
    </div>
  </div>

  <div class="table-card">
    <div class="table-scroll">
      <nz-table
        #fleetTable
        [nzData]="items"
        [nzLoading]="false"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        nzSize="middle">
        <thead>
          <tr>
            <th>Placa</th>
            <th>Veículo</th>
            <th>Empresa</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of fleetTable.data"
            class="clickable-row"
            (click)="openVehicle(item)">
            <td>
              <span class="plate-badge">{{ item.chassis | uppercase }}</span>
            </td>
            <td>
              <div class="vehicle-cell">
                <img
                  *ngIf="item.product_image"
                  class="vehicle-thumb"
                  [src]="item.product_image"
                  [alt]="item.product_name || item.chassis" />
                <span class="vehicle-name">{{ item.product_name || '-' }}</span>
              </div>
            </td>
            <td>{{ item.company_name || '-' }}</td>
          </tr>
        </tbody>
        <ng-template nzNoResult>
          <nz-empty
            nzNotFoundContent="Nenhum veículo encontrado"
            nzNotFoundImage="simple"
            class="list-empty"></nz-empty>
        </ng-template>
      </nz-table>
    </div>
  </div>

  <div class="table-footer" *ngIf="total > 0">
    <nz-pagination
      #pager
      [nzPageIndex]="currentPage"
      [nzPageSize]="currentPageSize"
      (nzPageIndexChange)="onPageChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)"
      [nzTotal]="total"
      nzResponsive="true"
      nzShowSizeChanger></nz-pagination>
  </div>
</div>
